import React, { createContext, useState } from 'react';
import produce from 'immer';

export type Filters = {
  startDate: string | null;
  endDate: string | null;
  application: string | null;
  errorCode: string | null;
  scriptStatus: string | null;
};

type ProviderState = {
  filters: Filters;
};

type ContextValue = ProviderState & {
  setFilter: <T extends keyof Filters>(filterKey: T, value: Filters[T]) => void;
};

const initialState: ProviderState = {
  filters: {
    startDate: null,
    endDate: null,
    application: null,
    errorCode: null,
    scriptStatus: null,
  },
};

export const FiltersContext = createContext<ContextValue>({
  ...initialState,
  setFilter: () => {},
});

type FiltersProviderProps = {
  children: React.ReactElement | React.ReactElement[];
};

export const FiltersProvider: React.FC<FiltersProviderProps> = ({ children }) => {
  const [state, setState] = useState(initialState);

  const value: ContextValue = {
    filters: state.filters,

    setFilter: <T extends keyof Filters>(filterKey: T, value: Filters[T]) => {
      setState(
        produce((draft: ProviderState) => {
          draft.filters[filterKey] = value;
        })
      );
    },
  };

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};
